var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Slick',{ref:"slick",attrs:{"options":_vm.slickOptions}},_vm._l((_vm.items),function(item){return _c('span',{key:item.comapny},[_c('div',[_c('img',{staticClass:"max-w-11rem max-w-md-13rem mx-auto",attrs:{"src":require('@/assets/img/partners/' + item.image_url)}})])])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }